import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "result-card-modal" }
const _hoisted_2 = { class: "close-modal d-flex justify-content-between align-items-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "dashed-line" }, null, -1)
const _hoisted_4 = { id: "printable-container" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "logo-result" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "logoShareResult-right" }),
  /*#__PURE__*/_createElementVNode("div", { class: "logoShareResult-left" }, [
    /*#__PURE__*/_createElementVNode("span", null, " Powered by "),
    /*#__PURE__*/_createElementVNode("div", { class: "clinicarx-logo" })
  ])
], -1)
const _hoisted_6 = { class: "logomark open-sans-font" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Powered by ")
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "custom-footer d-flex justify-content-center align-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_result_card = _resolveComponent("result-card")!
  const _component_base_modal = _resolveComponent("base-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_base_modal, {
      class: "custom-modal",
      ref: "base-modal"
    }, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", {
            class: "share-span",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.socialShare && _ctx.socialShare(...args)))
          }, " Compartilhar "),
          _createElementVNode("span", {
            class: "close-span",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleModal(false)))
          }, " Fechar ")
        ])
      ]),
      content: _withCtx(() => [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createVNode(_component_result_card, { class: "custom-result-card" }),
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("img", { src: _ctx.logoWhitePath }, null, 8, _hoisted_8)
          ])
        ])
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("span", {
            class: "share-span-footer",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.socialShare && _ctx.socialShare(...args)))
          }, " Compartilhar ")
        ])
      ]),
      _: 1
    }, 512)
  ]))
}